module.exports = __webpack_public_path__ + "img/b2_p_m.ba69c9fa.svg";